module.exports = __webpack_public_path__ + "img/rule-bg.0db26706.png";